import { render, staticRenderFns } from "./chineseplus_live2022.vue?vue&type=template&id=e82ad6f6&scoped=true"
import script from "./chineseplus_live2022.vue?vue&type=script&lang=js"
export * from "./chineseplus_live2022.vue?vue&type=script&lang=js"
import style0 from "./chineseplus_live2022.vue?vue&type=style&index=0&id=e82ad6f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ad6f6",
  null
  
)

export default component.exports